import { render, staticRenderFns } from "./ProtospellingSelect.vue?vue&type=template&id=d37fec38&"
import script from "./ProtospellingSelect.vue?vue&type=script&lang=js&"
export * from "./ProtospellingSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports